<div class="product-wrapper section-gap">
    <div class="container">
        <div class="section-gap-mini"></div>
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item"><a routerLink="/home">Home</a></li>
                        <li class="breadcrumb-item active" aria-current="page">{{area}}</li>
                    </ol>
                </nav>
            </div>
        </div>
        <div class="related-post mb-3">
            <!-- <h2 class="mb-5 text-capitalize">Documentos</h2> -->
            <div class="row">
                <div class="col-sm-6 col-md-3 col-lg-3" *ngFor="let doc of documentos">
                    <div class="card border-0 mb-4">
                        <div class="overlay-wrap mb-4 card-shadow border-rad">
                            <img class="img-fluid border-rad w-100" src="assets/derminas/documentos.jpg" alt="Documento"
                                width="280" height="260" />

                            <div style="cursor: pointer;"
                                class="card-img-overlay primary-tp-layer pos-center text-center" (click)="baixar(doc)"
                                [class.disabled-overlay]="inSpinner">
                                <span class="center-holder">

                                    <!-- Ícone de loading ou de download -->
                                    <a class="ih-fade-down square-40 rounded-circle bg-white shadow-md">
                                        <ng-container *ngIf="inSpinner; else downloadIcon">
                                            <i class="fa fa-spinner fa-spin align-middle"></i>
                                        </ng-container>
                                        <ng-template #downloadIcon>
                                            <i class="fa fa-cloud-download align-middle"></i>
                                        </ng-template>
                                    </a>

                                    <br />
                                    <span style="text-transform: uppercase;font-weight: bold; color: #FFFFFF;">
                                        {{ inSpinner ? 'Carregando...' : 'Clique para baixar' }}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <div class="card-body p-0" style="text-align: center;">
                            <h6 class="text-capitalize mb-3">{{doc.titulo}}</h6>
                            <p *ngIf="doc.subTitulo !== null">{{doc.subTitulo}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>